import * as React from "react";
import {createRoot} from "react-dom/client";
import {getOrderedCatalogueCategories} from "./helper/cataloguesHelper";
import {retrieveInformation} from "./helper/retrieveInformation";
import CatalogueSwiper from "./CatalogueSwiper";

class PublitasPortal {
  public static run(element: HTMLDivElement): void {
    const usp = new URLSearchParams(window.location.search);
    // See if url param is set. Possibly by a clicked anchor in the _`<CatalogueThumbs/>`_ React.FC
    const publitasMediumSlug = usp.get("publitas-medium");
    // if slug is empty string, just load the most recent activated catalogue, see publitas v1 api docs
    const srcUrl = "https://view.publitas.com/connox/" + (publitasMediumSlug || "") + "\u003Fpublitas_embed=maximized";

    // This event listener listens to a message sent by publitas script
    // it gives clue about the loaded catalogue (when slug is empty.. see above)
    window.addEventListener("message", (message: MessageEvent<string>) => {
      try {
        const messageData = JSON.parse(message.data) as ["publitasEcomInit", string, string];
        if (messageData[0] === "publitasEcomInit") {
          // take the slug sent by publitas message, and make the corresponding 'div.slug-name' container visible
          // all containers are formerly set to hidden by TextLong pseudotags
          document.body.querySelector(`.${messageData[2]} + .hide`)?.classList.remove("hide");
        }
      } catch (e) {
        return;
      }
    });

    // Render iframe with currect publitas catalogue
    const root = createRoot(element);
    root.render(
      <iframe
        src={srcUrl}
        style={{display: "block", boxSizing: "border-box"}}
        frameBorder="0"
        allowFullScreen={true}
      />,
    );

    // Below iframe: render every publication into their respective category
    const cataloguesContainer = document.body.getElementsByClassName("catalogues-container")[0];
    if (!cataloguesContainer) {
      return;
    }

    // Just temporary spinners into the `{kataloge}` blocks from $TextCross/Ergänzungstext, until the
    // async requests have returned from `retrieveInformation()` below
    Array.from(cataloguesContainer.getElementsByClassName("kataloge")).forEach((katalogDiv: HTMLDivElement) => {
      // spaces to give that `<p>` some height
      katalogDiv.innerHTML = "<p>\u00A0<span class='swiper-lazy-preloader'></span>\u00A0</p>";
    });

    // Get data from publitas api
    void retrieveInformation().then((catalogues) => {
      // retrieve structured object with catalogues placed in their respective category
      const cataloguesCategories = getOrderedCatalogueCategories(catalogues);

      cataloguesCategories.map((categoryData) => {
        // find anchor with the correct id (just for locating)
        let renderElement = document.getElementById(categoryData.anchorId);
        // actually parent element is needed to find the following siblings
        if (renderElement) renderElement = renderElement.parentElement;

        while (renderElement) {
          // get the next sibling
          renderElement = renderElement.nextElementSibling as HTMLElement;
          // when current sibling is `div.kataloge` container (see $TextCross/Ergänzungstext)
          if (renderElement && renderElement.classList.contains("kataloge")) {
            // Render the catalogues from respective category into container
            const root2 = createRoot(renderElement);
            root2.render(<CatalogueSwiper catalogues={categoryData.catalogues} />);

            return;
          }
        }
      });
    });
  }
}

export default PublitasPortal;
